<template>
  <div>
    <v-container>
      <v-row>
        <v-expansion-panels multiple v-model="panel">
          <v-expansion-panel>
            <v-expansion-panel-header>Date</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                  <custom-datepicker
                    :class-padding="classPadding"
                    label="Date From"
                    v-model="dateFrom"
                  ></custom-datepicker>
                </v-col>
                <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                  <custom-datepicker
                    :class-padding="classPadding"
                    label="Date To"
                    v-model="dateTo"
                  ></custom-datepicker>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Employee List</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
                <employee-selection
                  :show-dense="false"
                  :show-select="true"
                  v-model="employees"
                  :pay-loc="payLoc"
                ></employee-selection>
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <br />
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-radio-group row v-model="group2" :class="classPadding">
            <v-radio label="For Completion" value="0"></v-radio>
            <v-radio label="Completed" value="1"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
const EmpLookup = () =>
  import("../../maintenance/employee-masterfile/personal-info/Lookup");

const EmployeeSelection = () =>
  import(
    "../../maintenance/employee-masterfile/personal-info/NewHireSelection"
  );
const PayLocSelection = () =>
  import("../../setup/general/payroll-location/NewSelection");

const CustomDatepicker = () => import("@/components/CustomDatepicker");
import moment from "moment";

const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmp: {},
    signatory: {},
    letterContents: [],
    loading: false,
    messageCode: null,
    employees: [],
    payLoc: [],
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId",
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName",
      },
    ],
    panel: [0],
    dateFrom: null,
    dateTo: null,
    group2: "0",
  }),
  components: {
    EmpLookup,
    EmployeeSelection,
    CustomDatepicker,
  },
  computed: {
    ...mapState("other", ["client"]),
    empCodes() {
      return this.employees.join(", ");
    },
  },
  methods: {
    exportReport() {
      this.loading = true;
      var data = {
        EmpCode: this.empCodes,
        DateTo: moment(this.dateTo).format("MM/DD/YYYY"),
        DateFrom: moment(this.dateFrom).format("MM/DD/YYYY"),
        Group: this.group2,
      };

      var url = `${API_ENDPOINT}/onboarding`;

      this.$axios
        .post(`${url}`, data)
        .then(({ data }) => {
          var nameOfTheCsv = "Onboarding.xlsx";
          this.$axios
            .get(`${API_ENDPOINT}/onboarding/${data}`, { responseType: "blob" })
            .then((response) => {
              const downloadUrl = window.URL.createObjectURL(
                new Blob([response.data])
              );
              const link = document.createElement("a");
              link.href = downloadUrl;
              link.setAttribute("download", nameOfTheCsv);
              document.body.appendChild(link);
              link.click();
              link.remove();
            })
            .catch((err) => console.log(err));
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    // this.getLetterContents();
  },
};
</script>
